import { Component, inject } from '@angular/core';
import { TenantService } from './tenant.service';

@Component({
  selector: 'app-tenant-not-found-page',
  standalone: true,
  templateUrl: './tenant-not-found.page.html',
  styleUrl: './tenant-not-found.page.scss',
})
export class TenantNotFoundPage {
  protected readonly tenant = inject(TenantService);
}
